exports.NotificationConfigPageView = require('./NotificationConfigPageView').default;
exports.NotificationConfigDetailPageView = require('./NotificationConfigDetailPageView').default;
exports.NotificationConfigEditPageView = require('./NotificationConfigEditPageView').default;
